import React from 'react'
import styled from 'styled-components'

import MobileList from './MobileList'

import animation from './animation.styled'
import { theme } from 'styled-tools'
import MobileClientOrDoctor from './MobileClientOrDoctor'

const Wrapper = styled.div`
	min-height: 50px;
	${animation}
	background-color: ${theme('colors.white')};
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
`

/**
 * Componente "Wrapper" do menu mobile. Recebe a prop toolbar do Reakit, state do RTG e ações para chavear o menu e tipo
 */
export default function MobileMenu({
	toolbar,
	state,
	toggleMenu,
	toggleType,
	type,
	regionais,
	contatos,
	menuItens,
	colorIcon,
	onSearch,
	...props
}) {
	return (
		<Wrapper state={state}>
			<MobileClientOrDoctor toolbar={toolbar} toggleType={toggleType} type={type} />
			<MobileList toggleMenu={toggleMenu} menuItens={menuItens} />
		</Wrapper>
	)
}
